module.exports = __webpack_public_path__ + "img/default-mobile-arabic-no-content.5e24b4e2.png";